const JOUR_MS = 86_400_000;

const isoToUtc = (iso) => Date.parse(`${iso.slice(0, 10)}T00:00:00Z`);
const utcToIso = (ms) => new Date(ms).toISOString().slice(0, 10);

function dateUtcValide(iso) {
  if (!iso) return null;
  const ms = isoToUtc(iso);
  return Number.isFinite(ms) ? ms : null;
}

function fusionnerIntervalles(intervalles) {
  const fusionnes = [];
  for (const intervalle of [...intervalles].sort((a, b) => a.debut - b.debut)) {
    const dernier = fusionnes[fusionnes.length - 1];
    if (dernier && intervalle.debut <= dernier.fin) {
      dernier.fin = Math.max(dernier.fin, intervalle.fin);
    } else {
      fusionnes.push({ ...intervalle });
    }
  }
  return fusionnes;
}

// Renvoie [{ debut, finExclusive }] (dates ISO), ou null si le lot n'est pas planifié.
export function buildLotSegments(lot, taches) {
  if (!lot.date_debut_prevue || lot.duree_jours === null || lot.duree_jours === undefined) return null;

  const lotDebut = isoToUtc(lot.date_debut_prevue);
  const lotFin = lotDebut + Math.max(lot.duree_jours, 1) * JOUR_MS;
  if (!Number.isFinite(lotDebut)) return null;

  const datesTaches = taches
    .filter((t) => t.lot_id === lot.id)
    .map((t) => ({ debut: dateUtcValide(t.start_date), fin: dateUtcValide(t.target_date) }));

  const intervallesTaches = datesTaches.flatMap(({ debut, fin }) => {
    if (debut === null) return [];
    if (fin === null) return [{ debut, fin: debut + JOUR_MS }];
    return fin >= debut ? [{ debut, fin: fin + JOUR_MS }] : [];
  });
  const segmentsDates = fusionnerIntervalles([{ debut: lotDebut, fin: lotFin }, ...intervallesTaches]);

  const prolongationsSansDebut = datesTaches.flatMap(({ debut, fin }) => {
    if (debut !== null || fin === null) return [];
    const segmentPrecedent = [...segmentsDates].reverse().find((segment) => segment.debut <= fin);
    return [{ debut: segmentPrecedent?.debut ?? fin, fin: fin + JOUR_MS }];
  });

  return fusionnerIntervalles([...segmentsDates, ...prolongationsSansDebut]).map(({ debut, fin }) => ({
    debut: utcToIso(debut),
    finExclusive: utcToIso(fin),
  }));
}

export function derniereFinExclusive(segments) {
  return segments[segments.length - 1].finExclusive;
}

export function finInclusive(segment) {
  return utcToIso(isoToUtc(segment.finExclusive) - JOUR_MS);
}
